const INITIAL_STATE = {
  triiderUser: JSON.parse(localStorage.getItem('triiderUser')),
  companies: [],
  loading: false,
  isPassword: false,
  email: '',
  isTokenValid: false,
};

// REQUEST -> SAGA -> CHAMADA API -> REDUCER -> SUCCESS

/**
 * Types
 */
export const Types = {
  LOGIN_REQUEST: 'auth/LOGIN_REQUEST',
  LOGIN_SUCCESS: 'auth/LOGIN_SUCCESS',
  FORGOT_PASS_SEND_EMAIL: 'auth/FORGOT_PASS_SEND_EMAIL',
  FORGOT_PASS_CHECK_TOKEN: 'auth/FORGOT_PASS_CHECK_TOKEN',
  FORGOT_PASS_UPDATE_PASS: 'auth_FORGOT_PASS_UPDATE_PASS',
  SET_NEW_PASSWORD: 'auth/SET_NEW_PASSWORD',
  SET_EMAIL: 'auth/SET_EMAIL',
  SET_TOKEN_VALID: 'auth/SET_TOKEN_VALID',
  LOGOUT: 'auth/LOGOUT',
  UPDATE_USER_REQUEST: 'auth/UPDATE_USER_REQUEST',
  UPDATE_BILLING_ADDRESS: 'auth/UPDATE_BILLING_ADDRESS',
  GET_COMPANIES_BY_USER_REQUEST: 'auth/GET_COMPANIES_BY_USER_REQUEST',
  GET_COMPANIES_BY_USER_SUCCESS: 'auth/GET_COMPANIES_BY_USER_SUCCESS',
  CHANGE_COMPANY_USER: 'auth/CHANGE_COMPANY_USER',
};

/**
 * Reducer
 */
export default function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.LOGIN_SUCCESS:
      return { ...state, triiderUser: action.payload };
    case Types.SET_NEW_PASSWORD:
      return { ...state, isPassword: action.payload };
    case Types.SET_EMAIL:
      return { ...state, email: action.payload };
    case Types.SET_TOKEN_VALID:
      return { ...state, isTokenValid: action.payload };
    case Types.LOGOUT: {
      localStorage.clear();
      sessionStorage.clear();

      // clear cookies
      document.cookie.split(';').forEach((c) => {
        document.cookie = c.replace(/^ +/, '')
          .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
      });

      window.location.reload();

      return {
        ...state,
        triiderUser: null,
      };
    }
    case Types.GET_COMPANIES_BY_USER_SUCCESS:
      return { ...state, companies: action.payload };
    case Types.UPDATE_BILLING_ADDRESS:
      return {
        ...state,
        triiderUser: {
          ...state.triiderUser,
          company: {
            ...state.triiderUser.company,
            billing_address_id: action.payload.id,
            billing_address: { ...action.payload },
          },
        },
      };
    default:
      return state;
  }
}

/**
 * Helpers
 */
const isUserAuth = triiderUser => !!(triiderUser && triiderUser.token && triiderUser.user && triiderUser.user.id);

export const isAuth = (state) => {
  const { triiderUser } = state.auth;
  return isUserAuth(triiderUser);
};

export const getToken = (state) => {
  const { triiderUser } = state.auth;
  return triiderUser.token;
};

export const getTriiderUser = (state) => {
  const { triiderUser } = state.auth;
  return triiderUser;
};

export const getCompany = (state) => {
  const triiderUser = getTriiderUser(state);

  return triiderUser.company;
};

/**
 * Actions Creators
 */
export const Creators = {
  loginRequest: payload => ({
    type: Types.LOGIN_REQUEST,
    payload,
  }),

  loginSuccess: payload => ({
    type: Types.LOGIN_SUCCESS,
    payload,
  }),

  forgotPasswordSendEmailrequest: payload => ({
    type: Types.FORGOT_PASS_SEND_EMAIL,
    payload,
  }),

  forgotPasswordCheckTokenRequest: payload => ({
    type: Types.FORGOT_PASS_CHECK_TOKEN,
    payload,
  }),

  forgotPasswordUpdatePasswordRequest: payload => ({
    type: Types.FORGOT_PASS_UPDATE_PASS,
    payload,
  }),

  setNewPassword: payload => ({
    type: Types.SET_NEW_PASSWORD,
    payload,
  }),

  setEmail: payload => ({
    type: Types.SET_EMAIL,
    payload,
  }),

  setTokenValid: payload => ({
    type: Types.SET_TOKEN_VALID,
    payload,
  }),

  updateTriiderUserRequest: payload => ({
    type: Types.UPDATE_USER_REQUEST,
    payload,
  }),

  updateBillingAdress: payload => ({
    type: Types.UPDATE_BILLING_ADDRESS,
    payload,
  }),
  logout: () => ({
    type: Types.LOGOUT,
  }),

  getCompaniesByUserRequest: payload => ({
    type: Types.GET_COMPANIES_BY_USER_REQUEST,
    payload,
  }),

  getCompaniesByUserSuccess: payload => ({
    type: Types.GET_COMPANIES_BY_USER_SUCCESS,
    payload,
  }),
  changeCompanyUserRequest: payload => ({
    type: Types.CHANGE_COMPANY_USER,
    payload,
  }),
};
